export const allMessageType = { key: -1, value: -1, text: 'ALL' };

export const messageType = {
  bidIncrement: {
    key: 2,
    value: 'B297BDA6-A864-EB11-80CF-005056AFAEEA',
    text: 'Bid Increment',
  },
  bidOverride: {
    key: 3,
    value: 'BC97BDA6-A864-EB11-80CF-005056AFAEEA',
    text: 'Bid Override Floor',
  },
  bid: { key: 1, value: 'B397BDA6-A864-EB11-80CF-005056AFAEEA', text: 'Bid' },
  bidRejected: {
    key: 4,
    value: 'C197BDA6-A864-EB11-80CF-005056AFAEEA',
    text: 'Bid Rejected',
  },
  bidRetracted: {
    key: 5,
    value: 'BB97BDA6-A864-EB11-80CF-005056AFAEEA',
    text: 'Bid Retract',
  },
  biddingClosed: {
    key: 6,
    value: 'B497BDA6-A864-EB11-80CF-005056AFAEEA',
    text: 'Bidding Closed',
  },
  biddingOpened: {
    key: 7,
    value: 'B797BDA6-A864-EB11-80CF-005056AFAEEA',
    text: 'Bidding Opened',
  },
  buyerMessage: {
    key: 8,
    value: 'BD97BDA6-A864-EB11-80CF-005056AFAEEA',
    text: 'Buyer Message',
  },
  clerkMessage: {
    key: 9,
    value: 'BF97BDA6-A864-EB11-80CF-005056AFAEEA',
    text: 'Clerk Message',
  },
  subjectTo: {
    key: 10,
    value: 'B897BDA6-A864-EB11-80CF-005056AFAEEA',
    text: 'If Sale',
  },
  laneEnded: {
    key: 11,
    value: 'BA97BDA6-A864-EB11-80CF-005056AFAEEA',
    text: 'Lane Ended',
  },
  lanePaused: {
    key: 12,
    value: 'B997BDA6-A864-EB11-80CF-005056AFAEEA',
    text: 'Lane Paused',
  },
  laneStarted: {
    key: 13,
    value: 'B097BDA6-A864-EB11-80CF-005056AFAEEA',
    text: 'Lane Started',
  },
  nextOnBlock: {
    key: 14,
    value: 'AF97BDA6-A864-EB11-80CF-005056AFAEEA',
    text: 'Next on Block',
  },
  noSale: {
    key: 15,
    value: 'B697BDA6-A864-EB11-80CF-005056AFAEEA',
    text: 'No Sale',
  },
  preBid: {
    key: 16,
    value: 'AE97BDA6-A864-EB11-80CF-005056AFAEEA',
    text: 'Pre Bid',
  },
  proxyBid: {
    key: 17,
    value: 'C097BDA6-A864-EB11-80CF-005056AFAEEA',
    text: 'Proxy Bid',
  },
  proxyBidDeleted: {
    key: 18,
    value: 'C297BDA6-A864-EB11-80CF-005056AFAEEA',
    text: 'Proxy Bid Deleted',
  },
  sellerMessage: {
    key: 19,
    value: 'BE97BDA6-A864-EB11-80CF-005056AFAEEA',
    text: 'Seller Message',
  },
  sold: {
    key: 20,
    value: 'B597BDA6-A864-EB11-80CF-005056AFAEEA',
    text: 'Sold',
  },
  startingBid: {
    key: 21,
    value: 'B197BDA6-A864-EB11-80CF-005056AFAEEA',
    text: 'Starting Bid',
  },
};
const sortAscending = (a, b, key) => (a[key] > b[key] ? 0 : -1);
const messagesInTextAscendingOrder = (a, b) => sortAscending(a, b, 'text');

export const messageTypeKeys = Object.keys(messageType);
export const messageTypeEntries = Object.entries(messageType);
export const messageTypeValues = Object.values(messageType).sort(
  messagesInTextAscendingOrder,
);
export const messageTypeValuesWithAll = [allMessageType, ...messageTypeValues];
